import { memo } from 'react';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { useConfirm } from '../../context/ConfirmContext';

const warrantyStatus = (expiry) => {
  if (!expiry) return null;
  const diff = new Date(expiry) - new Date();
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  if (days < 0) return { label: 'Warranty expired', cls: 'badge-danger' };
  if (days <= 90) return { label: `Warranty: ${days}d left`, cls: 'badge-warning' };
  return { label: 'Warranty OK', cls: 'badge-success' };
};

const ApplianceCard = ({ appliance }) => {
  const { removeAppliance } = useApp();
  const { confirm } = useConfirm();
  const warranty = warrantyStatus(appliance.warrantyExpiry);

  const lastService = appliance.serviceHistory.length > 0
    ? appliance.serviceHistory.reduce((latest, s) =>
        new Date(s.date) > new Date(latest.date) ? s : latest
      )
    : null;

  const handleDelete = async () => {
    if (!(await confirm({ title: 'Delete appliance', message: `"${appliance.name}" and its service history will be permanently removed.` }))) return;
    removeAppliance(appliance._id).catch(() => {});
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">
          <Link to={`/appliances/${appliance._id}`} style={{ color: 'inherit', textDecoration: 'none' }}>
            {appliance.name}
          </Link>
        </h3>
        {warranty && <span className={`badge ${warranty.cls}`}>{warranty.label}</span>}
      </div>
      <div className="card-body">
        {appliance.make && (
          <p className="card-detail" style={{ fontWeight: 500 }}>
            {appliance.make}{appliance.model ? ` ${appliance.model}` : ''}
          </p>
        )}
        {appliance.room && (
          <p className="card-detail" style={{ color: 'var(--muted)', fontSize: '0.82rem' }}>
            📍 {appliance.room.name}
          </p>
        )}
        <p className="card-detail" style={{ fontSize: '0.82rem', color: 'var(--muted)' }}>
          {appliance.serviceHistory.length} service record{appliance.serviceHistory.length !== 1 ? 's' : ''}
          {lastService && ` · Last: ${format(new Date(lastService.date), 'MMM d, yyyy')}`}
        </p>
      </div>
      <div className="card-actions">
        <Link to={`/appliances/${appliance._id}`} className="btn btn-secondary btn-sm">View</Link>
        <Link to={`/appliances/${appliance._id}/edit`} className="btn btn-secondary btn-sm">Edit</Link>
        <button className="btn btn-danger btn-sm" onClick={handleDelete}>Delete</button>
      </div>
    </div>
  );
};

export default memo(ApplianceCard);
